(function () {
  function initGuide(root) {
    root.querySelectorAll('[data-epr-read-more]').forEach((button) => {
      button.addEventListener('click', () => {
        const content = button.parentElement.querySelector('[data-epr-read-more-content]');
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        button.textContent = isOpen ? 'Read more' : 'Read less';
        content.hidden = isOpen;
      });
    });

    root.querySelectorAll('[data-epr-faq-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const answer = document.getElementById(button.getAttribute('aria-controls'));
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        button.querySelector('[data-epr-faq-icon]').classList.toggle('is-open', !isOpen);
        answer.hidden = isOpen;
      });
    });

    const toc = root.querySelector('[data-epr-toc]');
    const tocToggle = root.querySelector('[data-epr-toc-toggle]');

    if (toc && tocToggle) {
      const listItems = Array.from(toc.querySelectorAll('.epr-guide__toc-links li'));
      const links = listItems.map((item) => item.querySelector('a'));
      listItems.forEach((item, index) => item.style.setProperty('--toc-num', `"${index + 1}"`));
      const currentLabel = toc.querySelector('[data-epr-toc-current]');
      const moreButton = toc.querySelector('[data-epr-toc-more]');
      let activeIndex = 0;
      let showAll = false;

      function renderTocWindow() {
        const visibleCount = 5;
        const maxStart = Math.max(0, listItems.length - visibleCount);
        const start = showAll ? 0 : Math.min(Math.max(activeIndex - 2, 0), maxStart);
        const end = showAll ? listItems.length : start + visibleCount;

        listItems.forEach((item, index) => {
          item.classList.toggle('is-visible', index >= start && index < end);
        });

        if (moreButton) {
          const hiddenCount = Math.max(0, listItems.length - visibleCount);
          moreButton.hidden = hiddenCount === 0;
          moreButton.textContent = showAll ? 'Show fewer' : `… ${hiddenCount} more`;
        }
      }

      tocToggle.addEventListener('click', () => {
        const isOpen = toc.classList.toggle('is-open');
        tocToggle.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) renderTocWindow();
      });

      links.forEach((link) => {
        link.addEventListener('click', () => {
          toc.classList.remove('is-open');
          tocToggle.setAttribute('aria-expanded', 'false');
        });
      });

      if (moreButton) {
        moreButton.addEventListener('click', () => {
          showAll = !showAll;
          renderTocWindow();
        });
      }

      document.addEventListener('click', (event) => {
        if (!toc.contains(event.target)) {
          toc.classList.remove('is-open');
          tocToggle.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          toc.classList.remove('is-open');
          tocToggle.setAttribute('aria-expanded', 'false');
          tocToggle.focus();
        }
      });

      const sections = links
        .map((link) => {
          const target = document.querySelector(link.getAttribute('href'));
          if (target?.classList.contains('epr-us-map__anchor')) {
            return document.querySelector(`[data-epr-observer-id="${target.id}"]`) || target;
          }
          return target;
        })
        .filter(Boolean);

      function setActiveIndex(nextIndex) {
        activeIndex = Math.max(0, Math.min(nextIndex, links.length - 1));
        links.forEach((link, index) => {
          link.classList.toggle('is-current', index === activeIndex);
        });
        if (currentLabel) currentLabel.textContent = String(activeIndex + 1);
        renderTocWindow();
      }

      function updateActiveFromScroll() {
        const marker = Math.min(220, window.innerHeight * 0.35);
        let nextIndex = 0;

        sections.forEach((section, index) => {
          if (section.getBoundingClientRect().top <= marker) {
            nextIndex = index;
          }
        });

        setActiveIndex(nextIndex);
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            const active = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

            if (!active) return;

            const activeId = active.target.dataset.eprObserverId || active.target.id;
            const nextIndex = links.findIndex((link) => link.getAttribute('href') === `#${activeId}`);
            setActiveIndex(nextIndex < 0 ? 0 : nextIndex);
          },
          { rootMargin: '-20% 0px -65% 0px', threshold: [0.05, 0.25, 0.5] }
        );

        sections.forEach((section) => observer.observe(section));
      }

      let scrollFrame = null;
      window.addEventListener(
        'scroll',
        () => {
          if (scrollFrame) return;
          scrollFrame = window.requestAnimationFrame(() => {
            scrollFrame = null;
            updateActiveFromScroll();
          });
        },
        { passive: true }
      );
      window.addEventListener('hashchange', updateActiveFromScroll);
      window.requestAnimationFrame(updateActiveFromScroll);

      renderTocWindow();
    }
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-epr-guide]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      initGuide(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
